import {mapState} from 'vuex'

export default mapState({
    symplaParticipations: state => state.session.user.symplaParticipations.filter(participation => {
        return participation.event.categories.includes('event_support') && participation.percentCompleted >= 90
    })
})
